import React, { useMemo } from "react";

export default (form, errors) => {
    const hasErrors = useMemo(() => {
        const formFields = Object.keys(form).filter((key) => !form[key]);

        // if there is only 1 false inside of the set, then no errors are found
        const errorsSet = new Set(Object.values(errors));
        const errorsFound = !(errorsSet.size < 2 && errorsSet.has(false));

        if (formFields.length > 0 || errorsFound) return true;
        else return false;
    }, [form]);

    return hasErrors;
};
